import { Typography } from 'antd'
import { isEmpty } from 'lodash'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Redirect, Route, Switch } from 'react-router-dom'
import { Loader } from 'rsuite'
import { settingAssetUrl } from 'src/app/queries/signedMediaUrl'
import { ISettingTypeState } from '../siteSettings/components/settings'
import { EmailSuccess } from './components/EmailSuccess'
import { ForgotPassword } from './components/ForgotPassword'
import { Login } from './components/Login'
import { NewPassword } from './components/NewPassword'
import { ResetPassword } from './components/ResetPassword'
import { UpdatePassword } from './components/UpdatePassword'

export function AuthPage() {
  const [logo, setLogo] = useState('')
  const [applicationName, setApplicationName] = useState('')
  const [primaryColor, setPrimaryColor] = useState('')
  const settingTypeData: ISettingTypeState = useSelector((state: any) => state.settingType)

  useEffect(() => {
    if (!isEmpty(settingTypeData?.backendData)) {
      settingTypeData?.backendData?.['Theme settings']?.forEach((item: any) => {
        if (item?.name === 'mainLogo') setLogo(settingAssetUrl(item))
        if (item?.name === 'primaryColor') setPrimaryColor(item?.value)
      })
      settingTypeData?.backendData?.['Application Credentials']?.forEach((item: any) => {
        if (item?.name === 'applicationName') setApplicationName(item?.value)
      })
    }
  }, [settingTypeData])

  const bgGradient = primaryColor
    ? `linear-gradient(145deg, #0b2d59 0%, ${primaryColor}bb 80%, ${primaryColor} 100%)`
    : 'linear-gradient(145deg, #0b2d59 0%, #1a5c44 55%, #42b086 100%)'

  return (
    <div className='auth-wrapper' style={{ background: bgGradient }}>
      <div className='auth-bg-blob auth-bg-blob--1' />
      <div className='auth-bg-blob auth-bg-blob--2' />

      {/* Left — welcome text */}
      <div className='auth-branding-side'>
        <div className='auth-branding-side__content'>
          <div className='auth-branding-side__welcome'>Welcome To</div>
          <Typography.Title level={1} className='auth-branding-side__name'>
            {applicationName}
          </Typography.Title>
        </div>
      </div>

      {/* Right — floating form card */}
      <div className='auth-form-side'>
        <div className='auth-card'>
          <div className='text-center mb-3'>
            <img
              className='auth-card__logo img-fluid'
              src={logo}
              alt={applicationName || 'Bank Logo'}
            />
          </div>
          <div className='auth-card__body'>
            {settingTypeData?.loading ? (
              <div className='d-flex justify-content-center py-5'>
                <Loader size='md' />
              </div>
            ) : (
              <Switch>
                <Route path='/auth/login/:id?' component={Login} />
                <Route path='/auth/set-password/:id?' component={NewPassword} />
                <Route path='/auth/forgot-password' component={ForgotPassword} />
                <Route path='/auth/reset-password/:id' component={ResetPassword} />
                <Route path='/auth/success' component={EmailSuccess} />
                <Route path='/auth/update-password/:id?' component={UpdatePassword} />
                <Redirect from='/auth' exact={true} to='/auth/login' />
                <Redirect to='/auth/login' />
              </Switch>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
